// Shared CRM (outbound leads) option lists. Mirrors VALID_SOURCES / VALID_STATUSES /
// VALID_PRIORITIES in server/routes/crm.js.

export const LEAD_SOURCES = [
    { value: "website", label: "Website" },
    { value: "referral", label: "Referral" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "trade_show", label: "Trade show" },
    { value: "cold_outreach", label: "Cold outreach" },
    { value: "partner", label: "Partner" },
    { value: "other", label: "Other" },
    // Set only by supply-chain reporting (a business reported by a DYC license) — never
    // selectable when creating or editing a lead by hand.
    { value: "supply_chain", label: "Supply chain reporting", systemOnly: true },
];
export const MANUAL_LEAD_SOURCES = LEAD_SOURCES.filter((s) => !s.systemOnly);
export const leadSourceLabel = (value) => LEAD_SOURCES.find((s) => s.value === value)?.label || value || "";

export const LEAD_STATUSES = ["new", "active", "won", "lost", "converted"];
export const LEAD_PRIORITIES = ["hot", "warm", "cold"];

// Citation filter for supply-chain leads (GET /admin/crm/leads?citation=).
export const CITATION_FILTERS = [
    { value: "", label: "Any citations" },
    { value: "verified", label: "Cited by DYC licenses" },
    { value: "unverified", label: "Unverified only (pending registrations)" },
    { value: "none", label: "No longer cited" },
];

// A lead is a business; the contact person is optional.
export const leadDisplayName = (lead) =>
    lead.company || [lead.firstName, lead.lastName].filter(Boolean).join(" ") || lead.email || `Lead #${lead.id}`;
export const leadContactName = (lead) => [lead.firstName, lead.lastName].filter(Boolean).join(" ");
